import type { PlanAccent } from "@/app/[lang]/(home)/components/plan-pricing-card";
import type { Plan } from "@/services/plans/types";
import { isFreePlan } from "./is-free-plan";
import { PLAN_PRESENTATION_COPY } from "./plan-presentation.copy";

export interface PlanPresentation {
  accent: PlanAccent;
  badgeLabel: string;
  pitch: string;
  ctaLabel: string;
  highlighted: boolean;
}

/** "Tãmi Start" → "Start". O card já exibe o nome inteiro logo acima do botão. */
function shortName(name: string): string {
  return name.replace(/^\s*T[ãa]mi\s+/i, "").trim() || name;
}

/**
 * Como cada plano se apresenta, a partir da posição na escada e do destaque.
 *
 * Fica fora do componente porque é regra, não marcação — e assim tem teste.
 * A `description` cadastrada no plano é a fonte do pitch; o texto fixo só
 * entra enquanto o campo estiver vazio no admin.
 */
export function presentPlan(
  plan: Plan,
  index: number,
  highlightedId: string | undefined,
): PlanPresentation {
  const highlighted = plan.id === highlightedId;

  const isFree = isFreePlan(plan);

  const accent: PlanAccent = highlighted
    ? "green"
    : index === 0
      ? "pale"
      : "orange";

  return {
    accent,
    highlighted,
    badgeLabel: plan.priceOnRequest
      ? PLAN_PRESENTATION_COPY.badge.onRequest
      : isFree
        ? PLAN_PRESENTATION_COPY.badge.free
        : highlighted
          ? PLAN_PRESENTATION_COPY.badge.highlighted
          : PLAN_PRESENTATION_COPY.badge.default,
    pitch:
      plan.description ||
      (isFree
        ? PLAN_PRESENTATION_COPY.fallbackPitchFree
        : PLAN_PRESENTATION_COPY.fallbackPitchPaid),
    // Sob consulta o CTA vem de `resolveCtaLabel`, que o card já resolve — o
    // checkout está fechado e o caminho é falar com o time.
    ctaLabel: isFree
      ? PLAN_PRESENTATION_COPY.ctaFree
      : PLAN_PRESENTATION_COPY.ctaSubscribe(shortName(plan.name)),
  };
}
